import details from './details'

export default {
  title: 'SEHAT by Johnson & Johnson',
  slug: 'jnj',
  createdAt: '1610447333683',
  description:
    'Ainihanifa.com bercerita tentang minimalis jurnal terkait kehidupan pribadi, dan traveling oleh @ainihanifa',
  details,
  tint: '#000'
}
